export { default } from "./SharedAccountsLayout";
